import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { FanSymbol } from '../primitives/FanSymbol';
import { DT } from '../tokens';

/** Fan BHP — fan housing with inlet+outlet, CFM through, TP across, BHP at shaft. */
export function DiagramFanHorsepower() {
  // Fan housing (volute / scroll)
  const cx = 175, cy = 130;
  const r = 38;

  return (
    <DiagramCanvas>
      {/* Inlet duct (left) */}
      <Rect x={20} y={cy - 18} width={70} height={36} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      {/* Inlet flow arrows */}
      {[cy - 8, cy + 6].map((yp, i) => (
        <G key={i}>
          <Line x1={28} y1={yp} x2={82} y2={yp} stroke={DT.arrow} strokeWidth="1.5" />
          <Polygon points={`84,${yp} 78,${yp - 3} 78,${yp + 3}`} fill={DT.arrow} />
        </G>
      ))}

      {/* Volute scroll — spiral approximation */}
      <Path d={`M${cx - r - 4},${cy} A${r + 4},${r + 4} 0 1 1 ${cx + r},${cy + r + 8} L${cx + r + 50},${cy + r + 8}`}
        fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      <FanSymbol cx={cx} cy={cy} r={r - 4} />

      {/* Outlet (top right) — discharges right */}
      <Rect x={cx + r + 4} y={cy + r - 4} width={50} height={20} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={cx + r + 12} y1={cy + r + 6} x2={cx + r + 50} y2={cy + r + 6} stroke={DT.arrow} strokeWidth="1.5" />
      <Polygon points={`${cx + r + 52},${cy + r + 6} ${cx + r + 46},${cy + r + 3} ${cx + r + 46},${cy + r + 9}`} fill={DT.arrow} />

      {/* Motor + shaft (below) */}
      <Rect x={cx - 32} y={cy + r + 28} width={64} height={28} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" rx="3" />
      <SvgText x={cx} y={cy + r + 46} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">MOTOR</SvgText>
      {/* Shaft connection */}
      <Line x1={cx} y1={cy + r - 4} x2={cx} y2={cy + r + 28} stroke={DT.stroke} strokeWidth="3" />
      {/* Sheave indicator */}
      <Circle cx={cx} cy={cy + r + 12} r={6} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" />

      {/* Pressure taps SP_inlet, SP_outlet for ΔTP = TP */}
      <Line x1={50} y1={cy - 18} x2={50} y2={45} stroke={DT.leader} strokeWidth="1" strokeDasharray="2,2" />
      <Circle cx={50} cy={35} r={9} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <SvgText x={50} y={38} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">SP_in</SvgText>

      <Line x1={cx + r + 30} y1={cy + r - 4} x2={cx + r + 30} y2={45} stroke={DT.leader} strokeWidth="1" strokeDasharray="2,2" />
      <Circle cx={cx + r + 30} cy={35} r={9} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <SvgText x={cx + r + 30} y={38} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">SP_out</SvgText>

      {/* RPM circular arrow */}
      <Path d={`M${cx + r + 8},${cy - 10} A18,18 0 0 1 ${cx + r + 18},${cy + 14}`}
        fill="none" stroke={DT.varColor} strokeWidth="1.2" />
      <Polygon points={`${cx + r + 18},${cy + 14} ${cx + r + 22},${cy + 9} ${cx + r + 14},${cy + 12}`} fill={DT.varColor} />

      {/* Labels */}
      <LeaderLine x1={50} y1={cy - 10} x2={20} y2={210} varName="CFM" desc="airflow" anchor="start" />
      <LeaderLine x1={cx + r + 20} y1={50} x2={150} y2={210} varName="TP" desc="ΔTP across fan" anchor="middle" />
      <LeaderLine x1={cx} y1={cy + r + 56} x2={310} y2={210} varName="BHP" desc="brake HP" anchor="end" />
      <LeaderLine x1={cx + r + 18} y1={cy} x2={310} y2={70} varName="η" desc="fan efficiency" anchor="end" />

      <FormulaTag formula="BHP = (CFM · TP) / (6356 · η_fan)" />
    </DiagramCanvas>
  );
}
